module.exports = __webpack_public_path__ + "img/gamifinna-fly.c6b08b19.png";